import React from 'react';
import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { CombinationText, ScanIconWrap } from './styled';
import { Tooltip } from 'antd';
import { aiAlertsConfigSelector } from '@store/common/selectors';
import BetaIcon from '@icons/beta-icon.svg';
import AnalysisIcon from '@icons/aiAlerts/analysis.svg';
import ErrorIcon from '@icons/noc/threshold-critical.svg';
import { getCardinalityText } from '@components/aiAlerts/AlertsConfig/alertConfig.utils';
import { isConfigLoadingAtom, totalCombinationsAtom } from '@components/aiAlerts/atoms';
import { useHistory } from 'react-router-dom';

export default function DimensionScan() {
  const history = useHistory();
  const isLoading = useAtomValue(isConfigLoadingAtom);
  const totalCombinations = useAtomValue(totalCombinationsAtom);
  const isDataError = !isLoading && totalCombinations === 0;
  const displayConfigCombinations = () => {
    // the query param acts as the driver for the config popup being open
    // it's used to update the help urls in apphub
    history.push({
      search: `?${new URLSearchParams({ config: 'true' })}`,
    });
  };
  const handleDisplayConfig = () => !isLoading && !isDataError && displayConfigCombinations();
  const isEiProduct = window.conviva.module === 'EI';
  const isConfigFeatureEnabled = useSelector(aiAlertsConfigSelector);
  const tooltipMesg = isDataError && 'Error fetching from the system or traffic may be too low.';

  return (
    isEiProduct &&
    isConfigFeatureEnabled && (
      <Tooltip title={tooltipMesg}>
        <ScanIconWrap>
          <AnalysisIcon />
          <CombinationText>Scanning</CombinationText>
          <BetaIcon />
        </ScanIconWrap>
        <CombinationText
          isLoading={isLoading}
          onClick={handleDisplayConfig}
          isError={isDataError}
          isLink
        >
          {isDataError && <ErrorIcon />}
          {getCardinalityText(totalCombinations, 2, isLoading, isDataError)}
        </CombinationText>
      </Tooltip>
    )
  );
}
